import React from "react"
import FadeInUp from "../animate/FadeInUp"
import useLang from "../../hooks/useLang"

import "./aboutpage.css"

const AboutPage = ({
  founderName,
  founderRoles,
  founderMessageTitle,
  founderMessageText,
}) => {
  const isAr = useLang() === "ar"

  const eyebrow = isAr ? "كلمة المؤسس" : "FOUNDER'S MESSAGE"

  return (
    <div className="about-page" dir={isAr ? "rtl" : "ltr"}>
      <FadeInUp>
        <section className="bm-founder">
          <div className="container">
            <div className="bm-founder__card">
              <div className="bm-founder__accent" />

              <div className="bm-founder__content">
                <div className="bm-founder__top">
                  <span className="bm-founder__eyebrow">
                    <span className="bm-founder__eyebrow-dot" />
                    {eyebrow}
                  </span>

                  <div className="bm-founder__quote-mark" aria-hidden="true">
                    “
                  </div>
                </div>

                <h2 className="bm-founder__title">{founderMessageTitle}</h2>

                <div className="bm-founder__text-wrap">
                  <p className="bm-founder__text">{founderMessageText}</p>
                </div>

                <div className="bm-founder__footer">
                  <div className="bm-founder__author">
                    <h3 className="bm-founder__name">{founderName}</h3>
                    <p className="bm-founder__role">{founderRoles}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </FadeInUp>
    </div>
  )
}

export default AboutPage